import { Profiler } from 'react';
import { element, string } from 'prop-types';

import { componentLatch, addComponentMeasure } from '../../utilities/PerformanceUtilities';

/**
 * This is a higher-order component that provides performance logging for a component.
 */
export default function PerformanceLog(props) {
    const { children: child, label } = props;
    const id = label || child.type.name;

    return componentLatch(id)(
        <Profiler id={id} onRender={addComponentMeasure}>
            {child}
        </Profiler>
    );
}

PerformanceLog.propTypes = {
    children: element.isRequired,
    // eslint-disable-next-line react/require-default-props
    label: string,
};
